<template>
  <section class="apply-step apply-step1">
    <div class="apply-content page-content" :class="{'has-form': showForm }">
      <div class="title-wrap">
        <p class="title">
          <span>请上传车主本人身份证</span>
        </p>
      </div>
      <section class="upload-row">
        <photo-upload :photo="idcard_front" type="idCard" @uploadEnd="uploadEnd('idcard_front', $event)"></photo-upload>
        <photo-upload :photo="idcard_back" type="idCard" @uploadEnd="uploadEnd('idcard_back', $event)"></photo-upload>
      </section>
      <section class="upload-row" v-show="currentCard.need_idcard_hold === 1">
        <photo-upload :photo="idcard_hold" type="idCard" @uploadEnd="uploadEnd('idcard_hold', $event)"></photo-upload>
      </section>

    </div>
    <section class="apply-bottom">
      <div class="apply-form" v-show="showForm">
        <p class="form-title">请核对证件信息</p>
        <ul class="form-list">
          <li class="form-item">
            <label>姓&#12288;&#12288;名</label>
            <input type="text"
                   maxlength="20"
                   placeholder="请输入身份证姓名"
                   @change="formChange('name')"
                   v-model="formData.name">
          </li>
          <li class="form-item">
            <label>身份证号</label>
            <input type="text"
                   maxlength="20"
                   placeholder="请输入身份证号"
                   @change="formChange('number')"
                   v-model="formData.number">
          </li>
        </ul>
        <div class="form-err-tip" color-red-tip v-show="(formErrMsg || reqErrMsg) && showForm">
          <i class="iconfont etc-icon-warn"></i>
          <span class="err-note"><!--展示三种提示-->
          {{formErrMsg || reqErrMsg}}
          </span>
        </div>
      </div>
      <button cool-btn :disabled="formErrMsg || !allPhotoUpload" @click="apply">下一步</button>
    </section>
  </section>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
import BiMixin from '@/mixins/biMixin'
// config
import ETC from '@/config/etc.config'
import APP from '@/config/app.config'
// components
import PhotoUpload from '@/components/etc.photoUpload'
// store
import {mapState, mapMutations} from 'vuex'
// api
// import ApplyApi from '@/api/apply.api'
import reconApply from '@/api/reconApply.api'

// 未上传: 0, 上传中: 1; 识别成功: 2; 识别失败 上传失败: 3; 4:上传成功(OCR繁忙)
const BTN_NOT_ALLOW = [0, 1, 3] // 不展示表单

const FORM_CHECK_FIELD = ['name', 'number']
const FORM_ERR_MSG = {
  name: {isNull: '请输入姓名', err: '姓名格式不正确，请重填', REG: APP.NAME_REG},
  number: {isNull: '请输入身份证号', err: '身份证号有误，请检查', REG: APP.ID}
}
let customData = {
  contentH: 0,
  isIOS: ''
}

export default {
  name: 'uploadIDCard',
  mixins: [FunMixin, BiMixin],
  components: {
    PhotoUpload
  },
  data() {
    return {
      ETC,
      formData: {
        name: '',
        number: ''
      },
      idcard_front: {type: 'idcard_front', status: 0},
      idcard_back: {type: 'idcard_back', status: 0},
      idcard_hold: {type: 'idcard_hold', status: 0},
      allPhotoUpload: false,
      showForm: false,
      formErrMsg: '',
      reqErrMsg: ''
    }
  },
  computed: {
    ...mapState(
      [
        'currentCard',
        'currentIssuer',
        'currentOrder',
        'lastApplyInfo'
      ])
  },
  methods: {
    uploadEnd(type, data) {
      console.log('apply1 uploadEnd', type, data)
      let ocrResult = data.draft
      if (ocrResult) {
        if (ocrResult.number) ocrResult.number = ocrResult.number.replace(/(\S{14})(\S+)/g, '$1 $2').replace(/(\S{6})(\S+)/g, '$1 $2')
      } else {
        ocrResult = {}
        if (type === 'idcard_front') {
          ocrResult.name = ''
          ocrResult.number = ''
        }
      }
      this.formData = Object.assign({}, this.formData, ocrResult)
      this.canShowForm()
      this.checkForm()
    },
    async apply() {
      await this.m_clickDebounce('apply1')
      this.checkForm()
      if (this.formErrMsg) return
      let formData = Object.assign({}, this.formData)
      formData.number = formData.number.replace(/ /g, '')
      formData.draft_sn = this.lastApplyInfo.draft_sn.idCard

      try {
        this.m_showLoading('信息校验中')
        await reconApply.userUpdateDraftIdCard(formData)

        this.$router.push('uploadVehicle')
      } catch (e) {
        this.reqErrMsg = e.msg || ''
      } finally {
        this.m_loadingClose()
      }
    },
    canShowForm() {
      let checkP = ['idcard_front', 'idcard_back']
      let result = true
      if (this.currentCard.need_idcard_hold === 1) checkP.push('idcard_hold')
      for (let i in checkP) {
        if (BTN_NOT_ALLOW.indexOf(this[checkP[i]].status) > -1) {
          result = false
          break
        }
      }
      this.allPhotoUpload = result
      this.showForm = this.showForm || result
    },
    formChange(key) {
      let val = this.formData[key].trim()
      if (key === 'number') {
        val = val.replace(/ /g, '').replace(/(\S{14})(\S+)/g, '$1 $2').replace(/(\S{6})(\S+)/g, '$1 $2')
      }
      this.formData[key] = val
      this.checkForm()
    },
    checkForm() {
      if (!this.showForm) return
      const formData = Object.assign({}, this.formData)
      formData.number = formData.number ? formData.number.replace(/\s/g, '') : ''
      let result = true
      let msg = ''
      for (let i in FORM_CHECK_FIELD) {
        let k = FORM_CHECK_FIELD[i]
        if (FORM_ERR_MSG[k].isNull && !formData[k]) { // 需要验证空
          result = false
          msg = FORM_ERR_MSG[k].isNull
          break
        }
        if (FORM_ERR_MSG[k].err) {
          if (FORM_ERR_MSG[k].REG && !FORM_ERR_MSG[k].REG.test(formData[k])) {
            result = false
            msg = FORM_ERR_MSG[k].err
            break
          }
          if (FORM_ERR_MSG[k].handler && FORM_ERR_MSG[k].isErr(formData[k])) {
            result = false
            msg = FORM_ERR_MSG[k].err
            break
          }
        }
      }
      this.formErrMsg = msg
      // console.log('check Form', msg)
      return result
    },
    getLastInfo() {
      console.log(98898898, this.currentOrder)
      reconApply.userGetDraft({
        plate_no: this.currentOrder.plate_no,
        plate_color: this.currentOrder.plate_color + ''
      }).then(res => {
        console.log(23223, res)
        this.setLastApplyInfo(res)
        if (res && res.idCard) {
          this.formData = res.idCard
          let images = res.images
          this.idcard_front = Object.assign(this.idcard_front, images.idcard_front)
          this.idcard_back = Object.assign(this.idcard_back, images.idcard_back)
          this.idcard_hold = Object.assign(this.idcard_hold, images.idcard_hold)
          this.canShowForm()
          this.checkForm()
        }
      })
    },
    ...mapMutations([
      'setLastApplyInfo'
    ])
  },
  async mounted() {
    try {
      this.m_showLoading()
      await this.getLastInfo()
      this.canShowForm()
    } finally {
      this.m_loadingClose()
    }
  },
  async created() {
    customData.isIOS = await this.m_isIOS()
  }
}
</script>

<style scoped lang="scss">
@import "../../style/etc.apply";
.apply-step1 {
  @include routeViewMinH(360px);
  .apply-content.has-form {
    min-height: calc(100vh - 674px);
  }
  &.iphoneX .apply-content.has-form{
    min-height: calc(100vh - 674px - 34px);
  }
}
</style>
